import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';

export type StatusApuracao = {
    idStatusApuracao: number;
    dsStatusApuracao: string;
    statusApuracaoEnum: string;
};

export function GerarReembolsoStatusAutoComplete({
    sx,
    name,
    value,
    error,
    options,
    readOnly,
    disableClearable,
    multiple = false,
    disabled = false,
    onChange = () => {},
    requestOptions = {
        url: '/financeiro/statusapuracao',
        sort: [{ property: 'idStatusApuracao', direction: 'ASC' }],
        nested: true,
        limit: 50,
    },
}: CissAutoCompleteProps) {
    return (
        <CissAutoComplete
            sx={sx}
            name={name}
            value={value}
            error={error}
            options={options}
            multiple={multiple}
            onChange={onChange}
            disabled={disabled}
            readOnly={readOnly}
            disableClearable={disableClearable}
            size="small"
            label="Status"
            objectId="idStatusApuracao"
            optionStringTemplate="{dsStatusApuracao}"
            selectedStringTemplate="{dsStatusApuracao}"
            isOptionEqualToValue={(option: StatusApuracao, value: StatusApuracao) =>
                value && option && option.idStatusApuracao === value.idStatusApuracao
            }
            requestOptions={requestOptions}
        />
    );
}
